// Emoji for the picker, reactions and :shortcodes:. Each entry is
// [emoji, shortcode, Turkish search words]. Shortcodes follow Discord's names.
const CATEGORIES = [
  {
    id: "people",
    name: "İfadeler ve İnsanlar",
    icon: "😀",
    emojis: [
      ["😀", "grinning", "gülen yüz mutlu"],
      ["😃", "smiley", "gülen mutlu"],
      ["😄", "smile", "gülümseme mutlu"],
      ["😁", "grin", "sırıtma"],
      ["😆", "laughing", "kahkaha gülme"],
      ["😅", "sweat_smile", "terli gülme"],
      ["🤣", "rofl", "yerlere yatma gülme"],
      ["😂", "joy", "gözyaşı gülme kahkaha"],
      ["🙂", "slight_smile", "hafif gülümseme"],
      ["🙃", "upside_down", "ters yüz"],
      ["😉", "wink", "göz kırpma"],
      ["😊", "blush", "utangaç gülümseme"],
      ["😇", "innocent", "melek masum"],
      ["🥰", "smiling_face_with_3_hearts", "aşık kalpler"],
      ["😍", "heart_eyes", "aşık kalp gözler"],
      ["🤩", "star_struck", "yıldız gözler hayran"],
      ["😘", "kissing_heart", "öpücük"],
      ["😗", "kissing", "öpme"],
      ["😚", "kissing_closed_eyes", "öpücük"],
      ["😋", "yum", "lezzetli dil"],
      ["😛", "stuck_out_tongue", "dil çıkarma"],
      ["😜", "stuck_out_tongue_winking_eye", "dil göz kırpma"],
      ["🤪", "zany_face", "çılgın"],
      ["😝", "stuck_out_tongue_closed_eyes", "dil"],
      ["🤑", "money_mouth", "para"],
      ["🤗", "hugging", "sarılma"],
      ["🤭", "hand_over_mouth", "kıkırdama"],
      ["🤫", "shushing_face", "sessiz sus"],
      ["🤔", "thinking", "düşünme"],
      ["🤐", "zipper_mouth", "fermuar sus"],
      ["🤨", "face_with_raised_eyebrow", "kaş kaldırma şüphe"],
      ["😐", "neutral_face", "nötr ifadesiz"],
      ["😑", "expressionless", "ifadesiz"],
      ["😶", "no_mouth", "ağızsız"],
      ["😏", "smirk", "sinsi gülüş"],
      ["😒", "unamused", "sıkılmış"],
      ["🙄", "rolling_eyes", "göz devirme"],
      ["😬", "grimacing", "dişler gerilme"],
      ["🤥", "lying_face", "yalan pinokyo"],
      ["😌", "relieved", "rahatlamış"],
      ["😔", "pensive", "düşünceli üzgün"],
      ["😪", "sleepy", "uykulu"],
      ["🤤", "drooling_face", "salya"],
      ["😴", "sleeping", "uyuyan uyku"],
      ["😷", "mask", "maske hasta"],
      ["🤒", "thermometer_face", "hasta ateş termometre"],
      ["🤕", "head_bandage", "yaralı"],
      ["🤢", "nauseated_face", "mide bulantısı"],
      ["🤮", "face_vomiting", "kusma"],
      ["🤧", "sneezing_face", "hapşırma"],
      ["🥵", "hot_face", "sıcak terleme"],
      ["🥶", "cold_face", "soğuk donma"],
      ["🥴", "woozy_face", "sarhoş"],
      ["😵", "dizzy_face", "başı dönen"],
      ["🤯", "exploding_head", "kafa patlama şok"],
      ["🤠", "cowboy", "kovboy"],
      ["🥳", "partying_face", "parti kutlama"],
      ["😎", "sunglasses", "havalı güneş gözlüğü"],
      ["🤓", "nerd", "inek gözlük"],
      ["🧐", "face_with_monocle", "monokl inceleme"],
      ["😕", "confused", "kafası karışık"],
      ["😟", "worried", "endişeli"],
      ["🙁", "slight_frown", "hafif somurtma"],
      ["😮", "open_mouth", "şaşkın ağız açık"],
      ["😯", "hushed", "şaşkın"],
      ["😲", "astonished", "hayret"],
      ["😳", "flushed", "kızarmış utanma"],
      ["🥺", "pleading_face", "yalvaran"],
      ["😦", "frowning", "kaşları çatık"],
      ["😧", "anguished", "ıstırap"],
      ["😨", "fearful", "korkmuş"],
      ["😰", "cold_sweat", "soğuk ter"],
      ["😥", "disappointed_relieved", "hayal kırıklığı"],
      ["😢", "cry", "ağlama gözyaşı"],
      ["😭", "sob", "hüngür hüngür ağlama"],
      ["😱", "scream", "çığlık korku"],
      ["😖", "confounded", "şaşkın"],
      ["😣", "persevere", "sabır"],
      ["😞", "disappointed", "hayal kırıklığı üzgün"],
      ["😓", "sweat", "ter"],
      ["😩", "weary", "bitkin"],
      ["😫", "tired_face", "yorgun"],
      ["🥱", "yawning_face", "esneme"],
      ["😤", "triumph", "öfkeli burun"],
      ["😡", "rage", "öfke kızgın"],
      ["😠", "angry", "kızgın"],
      ["🤬", "face_with_symbols_over_mouth", "küfür"],
      ["😈", "smiling_imp", "şeytan"],
      ["👿", "imp", "kızgın şeytan"],
      ["💀", "skull", "kafatası ölü"],
      ["☠️", "skull_crossbones", "korsan"],
      ["💩", "poop", "kaka"],
      ["🤡", "clown", "palyaço"],
      ["👹", "japanese_ogre", "dev"],
      ["👻", "ghost", "hayalet"],
      ["👽", "alien", "uzaylı"],
      ["🤖", "robot", "robot"],
      ["😺", "smiley_cat", "kedi"],
      ["😸", "smile_cat", "kedi"],
      ["😹", "joy_cat", "kedi gülme"],
      ["😻", "heart_eyes_cat", "kedi kalp"],
      ["🙈", "see_no_evil", "maymun görmedim"],
      ["🙉", "hear_no_evil", "maymun duymadım"],
      ["🙊", "speak_no_evil", "maymun söylemedim"],
      ["👋", "wave", "el sallama merhaba selam"],
      ["🤚", "raised_back_of_hand", "el"],
      ["✋", "raised_hand", "el dur"],
      ["🖖", "vulcan", "vulkan selamı"],
      ["👌", "ok_hand", "tamam"],
      ["🤌", "pinched_fingers", "italyan"],
      ["✌️", "v", "zafer barış"],
      ["🤞", "fingers_crossed", "şans dilek"],
      ["🤟", "love_you_gesture", "seni seviyorum"],
      ["🤘", "metal", "metal rock"],
      ["🤙", "call_me", "ara beni"],
      ["👈", "point_left", "sol"],
      ["👉", "point_right", "sağ"],
      ["👆", "point_up_2", "yukarı"],
      ["👇", "point_down", "aşağı"],
      ["☝️", "point_up", "yukarı bir"],
      ["👍", "thumbsup", "beğen evet onay"],
      ["👎", "thumbsdown", "beğenme hayır"],
      ["✊", "fist", "yumruk"],
      ["👊", "punch", "yumruk"],
      ["👏", "clap", "alkış"],
      ["🙌", "raised_hands", "eller havada kutlama"],
      ["👐", "open_hands", "açık eller"],
      ["🤲", "palms_up_together", "dua"],
      ["🤝", "handshake", "tokalaşma anlaşma"],
      ["🙏", "pray", "dua teşekkür lütfen"],
      ["✍️", "writing_hand", "yazma"],
      ["💪", "muscle", "kas güç"],
      ["🧠", "brain", "beyin"],
      ["👀", "eyes", "gözler bakma"],
      ["👅", "tongue", "dil"],
      ["👄", "lips", "dudak"],
      ["👶", "baby", "bebek"],
      ["🧒", "child", "çocuk"],
      ["👦", "boy", "erkek çocuk"],
      ["👧", "girl", "kız çocuk"],
      ["👨", "man", "adam"],
      ["👩", "woman", "kadın"],
      ["🧓", "older_adult", "yaşlı"],
      ["👮", "police_officer", "polis"],
      ["🧑‍💻", "technologist", "yazılımcı bilgisayar"],
      ["🤷", "person_shrugging", "omuz silkme bilmiyorum"],
      ["🤦", "person_facepalming", "facepalm"],
      ["🙋", "person_raising_hand", "el kaldırma"],
      ["🙇", "person_bowing", "eğilme"],
      ["💃", "dancer", "dans"],
      ["🕺", "man_dancing", "dans"],
      ["👨‍👩‍👧", "family_mwg", "aile"],
    ],
  },
  {
    id: "nature",
    name: "Doğa",
    icon: "🐻",
    emojis: [
      ["🐶", "dog", "köpek"],
      ["🐱", "cat", "kedi"],
      ["🐭", "mouse", "fare"],
      ["🐹", "hamster", "hamster"],
      ["🐰", "rabbit", "tavşan"],
      ["🦊", "fox", "tilki"],
      ["🐻", "bear", "ayı"],
      ["🐼", "panda_face", "panda"],
      ["🐨", "koala", "koala"],
      ["🐯", "tiger", "kaplan"],
      ["🦁", "lion_face", "aslan"],
      ["🐮", "cow", "inek"],
      ["🐷", "pig", "domuz"],
      ["🐸", "frog", "kurbağa"],
      ["🐵", "monkey_face", "maymun"],
      ["🐔", "chicken", "tavuk"],
      ["🐧", "penguin", "penguen"],
      ["🐦", "bird", "kuş"],
      ["🦆", "duck", "ördek"],
      ["🦅", "eagle", "kartal"],
      ["🦉", "owl", "baykuş"],
      ["🐺", "wolf", "kurt"],
      ["🐴", "horse", "at"],
      ["🦄", "unicorn", "tek boynuzlu at"],
      ["🐝", "bee", "arı"],
      ["🐛", "bug", "böcek"],
      ["🦋", "butterfly", "kelebek"],
      ["🐌", "snail", "salyangoz"],
      ["🐢", "turtle", "kaplumbağa"],
      ["🐍", "snake", "yılan"],
      ["🐙", "octopus", "ahtapot"],
      ["🐬", "dolphin", "yunus"],
      ["🐳", "whale", "balina"],
      ["🦈", "shark", "köpekbalığı"],
      ["🐟", "fish", "balık"],
      ["🌵", "cactus", "kaktüs"],
      ["🎄", "christmas_tree", "yılbaşı ağacı"],
      ["🌲", "evergreen_tree", "çam ağaç"],
      ["🌳", "deciduous_tree", "ağaç"],
      ["🌴", "palm_tree", "palmiye"],
      ["🍀", "four_leaf_clover", "yonca şans"],
      ["🍁", "maple_leaf", "yaprak sonbahar"],
      ["🌸", "cherry_blossom", "kiraz çiçeği"],
      ["🌹", "rose", "gül çiçek"],
      ["🌻", "sunflower", "ayçiçeği"],
      ["🌷", "tulip", "lale"],
      ["🌞", "sun_with_face", "güneş"],
      ["🌙", "crescent_moon", "ay hilal"],
      ["⭐", "star", "yıldız"],
      ["🌟", "star2", "parlayan yıldız"],
      ["✨", "sparkles", "parıltı"],
      ["⚡", "zap", "şimşek elektrik"],
      ["🔥", "fire", "ateş yangın harika"],
      ["🌈", "rainbow", "gökkuşağı"],
      ["☀️", "sunny", "güneşli"],
      ["⛅", "partly_sunny", "parçalı bulutlu"],
      ["☁️", "cloud", "bulut"],
      ["🌧️", "cloud_rain", "yağmur"],
      ["⛈️", "thunder_cloud_rain", "fırtına"],
      ["❄️", "snowflake", "kar tanesi"],
      ["☃️", "snowman2", "kardan adam"],
      ["💧", "droplet", "damla su"],
      ["🌊", "ocean", "dalga deniz"],
    ],
  },
  {
    id: "food",
    name: "Yiyecek ve İçecek",
    icon: "🍔",
    emojis: [
      ["🍏", "green_apple", "yeşil elma"],
      ["🍎", "apple", "elma"],
      ["🍐", "pear", "armut"],
      ["🍊", "tangerine", "mandalina portakal"],
      ["🍋", "lemon", "limon"],
      ["🍌", "banana", "muz"],
      ["🍉", "watermelon", "karpuz"],
      ["🍇", "grapes", "üzüm"],
      ["🍓", "strawberry", "çilek"],
      ["🍒", "cherries", "kiraz"],
      ["🍑", "peach", "şeftali"],
      ["🥭", "mango", "mango"],
      ["🍍", "pineapple", "ananas"],
      ["🥥", "coconut", "hindistan cevizi"],
      ["🥝", "kiwi", "kivi"],
      ["🍅", "tomato", "domates"],
      ["🍆", "eggplant", "patlıcan"],
      ["🥑", "avocado", "avokado"],
      ["🥦", "broccoli", "brokoli"],
      ["🌶️", "hot_pepper", "acı biber"],
      ["🌽", "corn", "mısır"],
      ["🥕", "carrot", "havuç"],
      ["🥔", "potato", "patates"],
      ["🥐", "croissant", "kruvasan"],
      ["🍞", "bread", "ekmek"],
      ["🥖", "french_bread", "baget ekmek"],
      ["🧀", "cheese", "peynir"],
      ["🥚", "egg", "yumurta"],
      ["🍳", "cooking", "sahanda yumurta"],
      ["🥓", "bacon", "pastırma"],
      ["🍗", "poultry_leg", "tavuk but"],
      ["🍖", "meat_on_bone", "et"],
      ["🌭", "hotdog", "sosisli"],
      ["🍔", "hamburger", "hamburger"],
      ["🍟", "fries", "patates kızartması"],
      ["🍕", "pizza", "pizza"],
      ["🥙", "stuffed_flatbread", "döner dürüm"],
      ["🌮", "taco", "tako"],
      ["🍝", "spaghetti", "makarna spagetti"],
      ["🍜", "ramen", "ramen erişte"],
      ["🍣", "sushi", "suşi"],
      ["🍤", "fried_shrimp", "karides"],
      ["🍩", "doughnut", "donut"],
      ["🍪", "cookie", "kurabiye"],
      ["🎂", "birthday", "doğum günü pastası"],
      ["🍰", "cake", "pasta kek"],
      ["🍫", "chocolate_bar", "çikolata"],
      ["🍬", "candy", "şeker"],
      ["🍭", "lollipop", "lolipop"],
      ["🍦", "icecream", "dondurma"],
      ["🍿", "popcorn", "patlamış mısır"],
      ["☕", "coffee", "kahve çay sıcak"],
      ["🍵", "tea", "çay"],
      ["🥤", "cup_with_straw", "içecek"],
      ["🍺", "beer", "bira"],
      ["🍻", "beers", "şerefe"],
      ["🥂", "champagne_glass", "kadeh şerefe"],
      ["🍷", "wine_glass", "şarap"],
      ["🥃", "tumbler_glass", "viski"],
      ["🧃", "beverage_box", "meyve suyu"],
      ["🧊", "ice_cube", "buz"],
    ],
  },
  {
    id: "activities",
    name: "Etkinlikler",
    icon: "⚽",
    emojis: [
      ["⚽", "soccer", "futbol top"],
      ["🏀", "basketball", "basketbol"],
      ["🏈", "football", "amerikan futbolu"],
      ["⚾", "baseball", "beyzbol"],
      ["🎾", "tennis", "tenis"],
      ["🏐", "volleyball", "voleybol"],
      ["🎱", "8ball", "bilardo"],
      ["🏓", "ping_pong", "masa tenisi"],
      ["🏸", "badminton", "badminton"],
      ["🥊", "boxing_glove", "boks"],
      ["⛳", "golf", "golf"],
      ["🎣", "fishing_pole_and_fish", "balık tutma"],
      ["🎿", "ski", "kayak"],
      ["🏆", "trophy", "kupa ödül şampiyon"],
      ["🥇", "first_place", "birinci altın madalya"],
      ["🥈", "second_place", "ikinci gümüş"],
      ["🥉", "third_place", "üçüncü bronz"],
      ["🏅", "medal", "madalya"],
      ["🎮", "video_game", "oyun konsol"],
      ["🕹️", "joystick", "oyun kolu"],
      ["🎲", "game_die", "zar"],
      ["🧩", "jigsaw", "yapboz"],
      ["♟️", "chess_pawn", "satranç"],
      ["🎯", "dart", "dart hedef"],
      ["🎳", "bowling", "bovling"],
      ["🎨", "art", "sanat resim"],
      ["🎬", "clapper", "film sinema"],
      ["🎤", "microphone", "mikrofon şarkı"],
      ["🎧", "headphones", "kulaklık müzik"],
      ["🎼", "musical_score", "nota"],
      ["🎹", "musical_keyboard", "piyano"],
      ["🥁", "drum", "davul"],
      ["🎷", "saxophone", "saksafon"],
      ["🎸", "guitar", "gitar"],
      ["🎻", "violin", "keman"],
      ["🎉", "tada", "kutlama parti konfeti"],
      ["🎊", "confetti_ball", "konfeti"],
      ["🎈", "balloon", "balon"],
      ["🎁", "gift", "hediye"],
      ["🎃", "jack_o_lantern", "balkabağı cadılar bayramı"],
      ["🎆", "fireworks", "havai fişek"],
    ],
  },
  {
    id: "travel",
    name: "Seyahat ve Yerler",
    icon: "🚗",
    emojis: [
      ["🚗", "red_car", "araba"],
      ["🚕", "taxi", "taksi"],
      ["🚌", "bus", "otobüs"],
      ["🏎️", "race_car", "yarış arabası"],
      ["🚓", "police_car", "polis arabası"],
      ["🚑", "ambulance", "ambulans"],
      ["🚒", "fire_engine", "itfaiye"],
      ["🚲", "bike", "bisiklet"],
      ["🛵", "motor_scooter", "motor"],
      ["🚂", "steam_locomotive", "tren"],
      ["✈️", "airplane", "uçak"],
      ["🚀", "rocket", "roket"],
      ["🛸", "flying_saucer", "ufo"],
      ["🚁", "helicopter", "helikopter"],
      ["⛵", "sailboat", "yelkenli tekne"],
      ["🚢", "ship", "gemi"],
      ["🏠", "house", "ev"],
      ["🏢", "office", "ofis bina"],
      ["🏫", "school", "okul"],
      ["🏥", "hospital", "hastane"],
      ["🕌", "mosque", "cami"],
      ["🏰", "european_castle", "kale şato"],
      ["🗽", "statue_of_liberty", "özgürlük heykeli"],
      ["🗼", "tokyo_tower", "kule"],
      ["⛺", "tent", "çadır kamp"],
      ["🏖️", "beach", "plaj tatil"],
      ["🏝️", "island", "ada"],
      ["⛰️", "mountain", "dağ"],
      ["🌋", "volcano", "yanardağ"],
      ["🌍", "earth_africa", "dünya"],
      ["🗺️", "map", "harita"],
      ["🌃", "night_with_stars", "gece şehir"],
    ],
  },
  {
    id: "objects",
    name: "Nesneler",
    icon: "💡",
    emojis: [
      ["⌚", "watch", "saat"],
      ["📱", "iphone", "telefon"],
      ["💻", "computer", "bilgisayar laptop"],
      ["⌨️", "keyboard", "klavye"],
      ["🖥️", "desktop", "masaüstü bilgisayar"],
      ["🖱️", "mouse_three_button", "fare"],
      ["💾", "floppy_disk", "disket kaydet"],
      ["📷", "camera", "kamera fotoğraf"],
      ["🎥", "movie_camera", "video kamera"],
      ["📺", "tv", "televizyon"],
      ["📻", "radio", "radyo"],
      ["⏰", "alarm_clock", "çalar saat"],
      ["⏳", "hourglass_flowing_sand", "kum saati bekleme"],
      ["🔋", "battery", "pil batarya"],
      ["🔌", "electric_plug", "fiş priz"],
      ["💡", "bulb", "ampul fikir"],
      ["🔦", "flashlight", "el feneri"],
      ["🕯️", "candle", "mum"],
      ["💸", "money_with_wings", "uçan para"],
      ["💰", "moneybag", "para çantası"],
      ["💳", "credit_card", "kredi kartı"],
      ["💎", "gem", "elmas mücevher"],
      ["🔧", "wrench", "anahtar tamir"],
      ["🔨", "hammer", "çekiç"],
      ["⚙️", "gear", "ayar dişli"],
      ["🔫", "gun", "su tabancası"],
      ["💣", "bomb", "bomba"],
      ["🔪", "knife", "bıçak"],
      ["🛡️", "shield", "kalkan"],
      ["🔮", "crystal_ball", "kristal küre"],
      ["💊", "pill", "ilaç hap"],
      ["💉", "syringe", "şırınga aşı"],
      ["🧪", "test_tube", "deney tüpü"],
      ["🔑", "key", "anahtar"],
      ["🚪", "door", "kapı"],
      ["🛏️", "bed", "yatak"],
      ["🧸", "teddy_bear", "oyuncak ayı"],
      ["✉️", "envelope", "zarf mektup"],
      ["📦", "package", "paket kutu"],
      ["📌", "pushpin", "raptiye sabitle"],
      ["📎", "paperclip", "ataş"],
      ["✂️", "scissors", "makas"],
      ["📝", "pencil", "not kalem"],
      ["✏️", "pencil2", "kurşun kalem"],
      ["📚", "books", "kitaplar"],
      ["📖", "book", "kitap"],
      ["🔍", "mag", "büyüteç arama"],
      ["🔒", "lock", "kilit"],
      ["🔔", "bell", "zil bildirim"],
      ["📢", "loudspeaker", "duyuru hoparlör"],
    ],
  },
  {
    id: "symbols",
    name: "Semboller",
    icon: "❤️",
    emojis: [
      ["❤️", "heart", "kalp aşk sevgi kırmızı"],
      ["🧡", "orange_heart", "turuncu kalp"],
      ["💛", "yellow_heart", "sarı kalp"],
      ["💚", "green_heart", "yeşil kalp"],
      ["💙", "blue_heart", "mavi kalp"],
      ["💜", "purple_heart", "mor kalp"],
      ["🖤", "black_heart", "siyah kalp"],
      ["🤍", "white_heart", "beyaz kalp"],
      ["🤎", "brown_heart", "kahverengi kalp"],
      ["💔", "broken_heart", "kırık kalp"],
      ["❣️", "heart_exclamation", "kalp ünlem"],
      ["💕", "two_hearts", "iki kalp"],
      ["💞", "revolving_hearts", "dönen kalpler"],
      ["💓", "heartbeat", "kalp atışı"],
      ["💗", "heartpulse", "büyüyen kalp"],
      ["💖", "sparkling_heart", "parlayan kalp"],
      ["💘", "cupid", "ok kalp"],
      ["💝", "gift_heart", "hediye kalp"],
      ["💯", "100", "yüz tam puan"],
      ["💢", "anger", "öfke"],
      ["💥", "boom", "patlama"],
      ["💫", "dizzy", "baş dönmesi yıldız"],
      ["💦", "sweat_drops", "su damlaları"],
      ["💨", "dash", "hız rüzgar"],
      ["💬", "speech_balloon", "konuşma balonu mesaj"],
      ["💭", "thought_balloon", "düşünce balonu"],
      ["💤", "zzz", "uyku"],
      ["✅", "white_check_mark", "onay tik tamam"],
      ["☑️", "ballot_box_with_check", "onay kutusu"],
      ["✔️", "heavy_check_mark", "tik"],
      ["❌", "x", "çarpı hayır yanlış"],
      ["❎", "negative_squared_cross_mark", "çarpı"],
      ["➕", "heavy_plus_sign", "artı"],
      ["➖", "heavy_minus_sign", "eksi"],
      ["❓", "question", "soru işareti"],
      ["❗", "exclamation", "ünlem"],
      ["‼️", "bangbang", "çift ünlem"],
      ["⚠️", "warning", "uyarı dikkat"],
      ["🚫", "no_entry_sign", "yasak"],
      ["⛔", "no_entry", "giriş yok"],
      ["🔞", "underage", "18 yaş"],
      ["♻️", "recycle", "geri dönüşüm"],
      ["🔴", "red_circle", "kırmızı daire"],
      ["🟢", "green_circle", "yeşil daire"],
      ["🔵", "blue_circle", "mavi daire"],
      ["🟡", "yellow_circle", "sarı daire"],
      ["⚫", "black_circle", "siyah daire"],
      ["⚪", "white_circle", "beyaz daire"],
      ["🔺", "small_red_triangle", "üçgen"],
      ["⬆️", "arrow_up", "yukarı ok"],
      ["⬇️", "arrow_down", "aşağı ok"],
      ["⬅️", "arrow_left", "sol ok"],
      ["➡️", "arrow_right", "sağ ok"],
      ["🔄", "arrows_counterclockwise", "yenile"],
      ["🆗", "ok", "tamam"],
      ["🆕", "new", "yeni"],
      ["🆒", "cool", "havalı"],
      ["🆘", "sos", "yardım"],
      ["1️⃣", "one", "bir"],
      ["2️⃣", "two", "iki"],
      ["3️⃣", "three", "üç"],
      ["#️⃣", "hash", "diyez"],
      ["©️", "copyright", "telif"],
      ["™️", "tm", "marka"],
      ["🎵", "musical_note", "nota müzik"],
      ["🎶", "notes", "notalar müzik"],
    ],
  },
  {
    id: "flags",
    name: "Bayraklar",
    icon: "🏁",
    emojis: [
      ["🏁", "checkered_flag", "damalı bayrak yarış"],
      ["🚩", "triangular_flag_on_post", "kırmızı bayrak"],
      ["🏳️", "white_flag", "beyaz bayrak"],
      ["🏴", "black_flag", "siyah bayrak"],
      ["🏳️‍🌈", "rainbow_flag", "gökkuşağı bayrağı"],
      ["🇹🇷", "flag_tr", "türkiye bayrak"],
      ["🇦🇿", "flag_az", "azerbaycan bayrak"],
      ["🇩🇪", "flag_de", "almanya bayrak"],
      ["🇬🇧", "flag_gb", "ingiltere bayrak"],
      ["🇺🇸", "flag_us", "amerika abd bayrak"],
      ["🇫🇷", "flag_fr", "fransa bayrak"],
      ["🇮🇹", "flag_it", "italya bayrak"],
      ["🇪🇸", "flag_es", "ispanya bayrak"],
      ["🇳🇱", "flag_nl", "hollanda bayrak"],
      ["🇯🇵", "flag_jp", "japonya bayrak"],
      ["🇰🇷", "flag_kr", "kore bayrak"],
      ["🇧🇷", "flag_br", "brezilya bayrak"],
      ["🇷🇺", "flag_ru", "rusya bayrak"],
      ["🇺🇦", "flag_ua", "ukrayna bayrak"],
      ["🇸🇦", "flag_sa", "suudi arabistan bayrak"],
    ],
  },
];

export const EMOJI_CATEGORIES = CATEGORIES.map(category => ({
  ...category,
  emojis: category.emojis.map(([emoji, name, keywords]) => ({
    emoji,
    name,
    keywords,
  })),
}));

const ALL = EMOJI_CATEGORIES.flatMap(category => category.emojis);

const BY_NAME = new Map(ALL.map(entry => [entry.name, entry]));

// :thumbsup: -> 👍, or undefined for an unknown name
export const emojiForShortcode = name => {
  const entry = BY_NAME.get(String(name).toLowerCase());
  return entry && entry.emoji;
};

export const nameForEmoji = emoji => {
  const entry = ALL.find(item => item.emoji === emoji);
  return entry ? entry.name : "";
};

const normalize = text => String(text).toLocaleLowerCase("tr").trim();

// Best matches first: shortcodes starting with the query, then emoji whose
// main word is the query, then any word, then partial matches
const score = (entry, q) => {
  if (entry.name.startsWith(q)) return 0;
  const words = normalize(entry.keywords).split(" ");
  if (words[0] === q) return 1;
  if (words.includes(q)) return 2;
  if (words.some(word => word.startsWith(q))) return 3;
  if (entry.name.includes(q) || words.some(word => word.includes(q))) return 4;
  return -1;
};

export const searchEmoji = (query, limit = Infinity) => {
  const q = normalize(query).replace(/^:|:$/g, "");
  if (!q) return [];
  return ALL.map((entry, index) => ({ entry, index, rank: score(entry, q) }))
    .filter(item => item.rank >= 0)
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .slice(0, limit)
    .map(item => item.entry);
};

// Replaces known :shortcodes: in text the user typed, outside code
export const replaceShortcodes = text =>
  String(text)
    .split(/(```[\s\S]*?```|`[^`\n]*`)/)
    .map((part, index) =>
      index % 2 === 1
        ? part
        : part.replace(/:([a-z0-9_+-]+):/gi, (whole, name) => emojiForShortcode(name) || whole)
    )
    .join("");
